import { BaseService } from "./baseService";
import { OfflineModel, OfflineExtend } from '../model/offlineModel';

export class OfflineService extends BaseService {

    constructor() {
        super();
        this.tableName = "Offlines";
        this.OfflineExtend = new OfflineExtend();
    }

    async getOfflines() {
        let offlines = await this.connection.select({
            from: this.tableName
        });

        let dOfflines = [];

        offlines.forEach(item => {
            dOfflines.push(this.OfflineExtend.decryption(new OfflineModel(), item));
        });

        return dOfflines;
    }

    async getOfflineNames(siteId) {
        let offlines = await this.connection.select({
            from: this.tableName,
            where: {
                SiteId: siteId
            }
        });

        let dOfflines = [];

        offlines.forEach(item => {
            dOfflines.push(item.Name);
        });

        return dOfflines;
    }

    async getOfflinesBySite(siteId, name) {
        let offlines = await this.connection.select({
            from: this.tableName,
            where: {
                SiteId: siteId,
                Name: name
            }
        });

        let dOfflines = [];

        offlines.forEach(item => {
            dOfflines.push(this.OfflineExtend.decryption(new OfflineModel(), item));
        });

        return dOfflines[0];
    }

    removeOfflineBySite(siteId, name) {
        return this.connection.remove({
            from: this.tableName,
            where: {
                SiteId: siteId,
                Name: name
            }
        });
    }

    addOffline(siteId, name, data) {
        let offlineModel = new OfflineModel(null, siteId, name, data, null);
        this.OfflineExtend.encryption(offlineModel, offlineModel);

        return this.connection.insert({
            into: this.tableName,
            values: [offlineModel],
            skipDataCheck: true,
            return: false// since id is autoincrement field and we need id, 
            // so we are making return true which will return the whole data inserted.
        });
    }

    updateOfflineByName(siteId, name, updateData) {
        let offlineModel = new OfflineModel(null, siteId, name, updateData, null);
        this.OfflineExtend.encryption(offlineModel, offlineModel);

        return this.connection.update({
            in: this.tableName,
            set: offlineModel,
            where: {
                Name: name
            }
        });
    }

    removeOfflineByName(name) {
        return this.connection.remove({
            from: this.tableName,
            where: {
                Name: name
            }
        });
    }
}
